import React from 'react';
import DropdownContext from './DropdownContext';

function DropdownToggle(_ref) {
  var children = _ref.children;
  return React.createElement(DropdownContext.Consumer, null, function (_ref2) {
    var show = _ref2.show,
        toggle = _ref2.toggle,
        toggleRef = _ref2.toggleRef;
    return children({
      show: show,
      toggle: toggle,
      props: {
        ref: toggleRef,
        'aria-haspopup': true,
        'aria-expanded': !!show
      }
    });
  });
}

DropdownToggle.displayName = 'ReactOverlaysDropdownToggle';
export default DropdownToggle;